export const API_FORM_ERROR_FALLBACK_MESSAGE =
  "api_form_error_something_went_wrong";

export function resolveApiFormErrorMessage(response) {
  if (response?.message) {
    return response.message;
  }

  const validation = Array.isArray(response?.validation)
    ? response.validation
    : [];
  const firstValue = validation.find(item => item?.value)?.value;

  if (firstValue) {
    return firstValue;
  }

  return API_FORM_ERROR_FALLBACK_MESSAGE;
}
